import { j as r } from "./AccesRecoveryIcon-CUPieIxT.js";
const o = () => /* @__PURE__ */ r.jsxs("svg", { viewBox: "0 0 160 160", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ r.jsx(
    "path",
    {
      d: "M102.697 98.2167C94.8234 98.1067 92.02 94.7833 84.5834 84.8667C77.1467 74.95 69.19 75.4133 66.47 78.3967C64.2034 80.8767 77.5734 109.987 81.5634 114.623C83.4619 116.917 85.5156 119.078 87.71 121.09C87.71 121.09 87.5667 134.973 87.1367 145M124.15 142.547C122.435 133.922 121.176 125.214 120.377 116.457C120.593 115.377 120.46 100.93 120.363 97.48C120.267 94.03 116.603 64.92 114.123 59.42C111.643 53.92 102.697 46.6967 102.697 46.6967",
      stroke: "currentColor",
      strokeWidth: "6.66667",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      d: "M80.3334 112.9H43.5401C42.53 112.9 41.5297 112.701 40.5965 112.314C39.6633 111.928 38.8154 111.361 38.1013 110.646C37.3871 109.932 36.8208 109.084 36.4345 108.151C36.0482 107.217 35.8497 106.217 35.8501 105.207V22.69C35.8501 20.6505 36.6603 18.6945 38.1024 17.2523C39.5446 15.8102 41.5006 15 43.5401 15H95.0068C97.0463 15 99.0023 15.8102 100.444 17.2523C101.887 18.6945 102.697 20.6505 102.697 22.69V98.2167M35.8501 28.9067H102.697M35.8501 98.99H73.1401",
      stroke: "currentColor",
      strokeWidth: "6.66667",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      d: "M88.2334 66.4933C89.6141 66.4933 90.7334 65.3741 90.7334 63.9933C90.7334 62.6126 89.6141 61.4933 88.2334 61.4933C86.8527 61.4933 85.7334 62.6126 85.7334 63.9933C85.7334 65.3741 86.8527 66.4933 88.2334 66.4933Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      d: "M76.1067 66.4933C77.4874 66.4933 78.6067 65.3741 78.6067 63.9933C78.6067 62.6126 77.4874 61.4933 76.1067 61.4933C74.726 61.4933 73.6067 62.6126 73.6067 63.9933C73.6067 65.3741 74.726 66.4933 76.1067 66.4933Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      d: "M63.9834 66.4933C65.3641 66.4933 66.4834 65.3741 66.4834 63.9933C66.4834 62.6126 65.3641 61.4933 63.9834 61.4933C62.6027 61.4933 61.4834 62.6126 61.4834 63.9933C61.4834 65.3741 62.6027 66.4933 63.9834 66.4933Z",
      fill: "currentColor"
    }
  )
] });
export {
  o as T
};
